import React from 'react';

const ScatterChartIcon = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg viewBox="0 0 800 600" {...props}>
      <g transform="translate(150, 100)">
        <g className="ez-grid">
          <g className="ez-grid-lines">
            <line
              transform="translate(0, 400.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 350.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 300.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 250.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 200.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 150.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 100.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 50.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 0.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
          </g>
          <g className="ez-grid-lines">
            <line
              transform="translate(0.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(74.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(149.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(223.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(297.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(371.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(446.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(520.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(594.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
          </g>
        </g>
        <g className="ez-points">
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="0"
            cy="355"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="223"
            cy="175"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="594"
            cy="295"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="149"
            cy="250"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="446"
            cy="150"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="0"
            cy="305"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="223"
            cy="275"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="594"
            cy="250"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="149"
            cy="140"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="446"
            cy="75"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="0"
            cy="305"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="223"
            cy="25"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="594"
            cy="190"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="149"
            cy="250"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="446"
            cy="150"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="0"
            cy="305"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="223"
            cy="265"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="594"
            cy="205"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="149"
            cy="275"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
          <circle
            stroke="rgba(255, 0, 0, 1)"
            fill="rgba(255, 0, 0, 1)"
            r="5"
            cx="446"
            cy="75"
            strokeWidth="1"
            data-testid="ez-point"
            className="ez-point"
          ></circle>
        </g>
        <g
          textAnchor="middle"
          transform="translate(0, 400)"
          className="ez-axis"
        >
          <path d="M0.5,6V-6V-0.5H594.5V6V-6" className="ez-axis-path"></path>
          <g transform="translate(0.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              2
            </text>
          </g>
          <g transform="translate(74.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              3
            </text>
          </g>
          <g transform="translate(149.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              4
            </text>
          </g>
          <g transform="translate(223.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              5
            </text>
          </g>
          <g transform="translate(297.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              6
            </text>
          </g>
          <g transform="translate(371.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              7
            </text>
          </g>
          <g transform="translate(446.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              8
            </text>
          </g>
          <g transform="translate(520.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              9
            </text>
          </g>
          <g transform="translate(594.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              10
            </text>
          </g>
        </g>
        <g textAnchor="end" transform="translate(0, 0)" className="ez-axis">
          <path d="M6,400.5H-6H-0.5V0.5H6,-6" className="ez-axis-path"></path>
          <g transform="translate(0, 400.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              0
            </text>
          </g>
          <g transform="translate(0, 350.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              10
            </text>
          </g>
          <g transform="translate(0, 300.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              20
            </text>
          </g>
          <g transform="translate(0, 250.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              30
            </text>
          </g>
          <g transform="translate(0, 200.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              40
            </text>
          </g>
          <g transform="translate(0, 150.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              50
            </text>
          </g>
          <g transform="translate(0, 100.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              60
            </text>
          </g>
          <g transform="translate(0, 50.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              70
            </text>
          </g>
          <g transform="translate(0, 0.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              80
            </text>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default ScatterChartIcon;
